import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of, shareReplay } from 'rxjs';
import { protectedResources } from 'src/app/auth/auth.config';
import { BackendConfig } from '../models/build-info.model';

@Injectable({
  providedIn: 'root',
})
export class BuildInfoService {
  private apiEndpoint: string = protectedResources.apiTodoList.endpoint;
  private backendConfig$?: Observable<BackendConfig | null>;

  constructor(private http: HttpClient) {}

  /**
   * The endpoint is Masteradmin-only; a rejection or an unreachable backend
   * resolves to null so the footer simply omits the backend line.
   */
  getBackendConfig(): Observable<BackendConfig | null> {
    this.backendConfig$ ??= this.http
      .get<BackendConfig>(`${this.apiEndpoint}/admin/current-config`)
      .pipe(
        catchError(() => of(null)),
        shareReplay({ bufferSize: 1, refCount: false }),
      );

    return this.backendConfig$;
  }
}
